const genres:string[] = [
    'アクション',
	'RPG',
    'シュミレーション',
    'パズル',
]
export default genres

//todo、enum型にする？